<template>
    <div>
        <div class="customer-info">
            <div class="customers-info-section">
                <div class="row">
                    <div class="col-md-12">
                        <div class="filter-section sub-filter">
                            <div class="row sup-heading">
                                <div class="col-md-11">
                                    <h2 class="m-0">Setup Profile</h2>
                                </div>
                                <span class="edit-info" @click="editSetupProfile"><i class="icon-edit"></i>Edit
                                </span>
                            </div>
                        </div>
                        <ul>
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>Basic Information</h3>
                                        </div>

                                        <div v-for="(data, index) in basicInfo" :key="index" class="col-md-4">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>{{
                                    data.field
                                }}:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        data.value
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <!--Contact Info-->
                        <ul v-if="customerDetails.contactInfo">
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>Contact Information</h3>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Residential
                                                        Address:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                    customerDetails
                                        .contactInfo.address
                                }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Mailing Address:</label>
                                                </li>

                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .contactInfo
                                            .address2
                                            ? customerDetails
                                                .contactInfo
                                                .address2
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>State:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .contactInfo.state
                                            ? customerDetails
                                                .contactInfo
                                                .state
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>City:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .contactInfo.city
                                            ? customerDetails
                                                .contactInfo
                                                .city
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Are you a resident of
                                                        Pakistan?:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .basicInfo
                                            .permPakResident
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Country of
                                                        Residence:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .basicInfo
                                            .countryOfResidence
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Nationality:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .basicInfo
                                            .nationality
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Do you have other
                                                        Nationalities:</label>
                                                </li>

                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .basicInfo
                                            .hasOtherNationalities
                                            ? customerDetails
                                                .basicInfo
                                                .hasOtherNationalities
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Specify other
                                                        Nationalities:</label>
                                                </li>

                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .basicInfo
                                            .hasOtherNationalities ==
                                            'Yes'
                                            ? customerDetails.basicInfo.otherNationalities
                                                .map(
                                                    (e) =>
                                                        e.title
                                                )
                                                .join(', ')
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Email Address:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .contactInfo.email
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Phone Number:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span :class="{
                                        danger: customerDetails
                                            .contactInfo
                                            .isdCodeIsSanction,
                                    }">{{
                                    customerDetails
                                        .contactInfo
                                        .isdCode
                                }}
                                                        {{
                                        customerDetails
                                            .contactInfo
                                            .phoneNumber
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <!--End Contact Info-->

                        <!-- Bank Details -->
                        <ul v-if="customerDetails.accountInfo">
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>Bank Information</h3>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Bank Name:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                    customerDetails
                                        .accountInfo
                                        .bankName
                                        ? customerDetails
                                            .accountInfo
                                            .bankName
                                        : 'N/A'
                                }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Branch Name:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .accountInfo
                                            .bankBranch
                                            ? customerDetails
                                                .accountInfo
                                                .bankBranch
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Bank Account
                                                        Title:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .accountInfo
                                            .bankTitle
                                            ? customerDetails
                                                .accountInfo
                                                .bankTitle
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Branch Address:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .accountInfo
                                            .bankAddress
                                            ? customerDetails
                                                .accountInfo
                                                .bankAddress
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>IBAN/Account
                                                        No.:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .accountInfo
                                            .bankAccountNo
                                            ? customerDetails
                                                .accountInfo
                                                .bankAccountNo
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <!-- End Bank Details -->

                        <!-- Professional Information -->

                        <ul v-if="customerDetails.occupationInfo">
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>Professional Information</h3>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Education:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                    customerDetails
                                        .occupationInfo
                                        .education
                                        ? customerDetails
                                            .occupationInfo
                                            .education
                                        : 'N/A'
                                }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <!-- <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Work Type:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                                        customerDetails
                                                            .occupationInfo
                                                            .workType
                                                    }}</span>
                                                </li>
                                            </ul>
                                        </div> -->
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Industry:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span v-if="customerDetails
                                        .occupationInfo
                                        .industry
                                    " class="">{{
                                    customerDetails
                                        .occupationInfo
                                        .industry
                                }}</span>
                                                    <span v-else>N/A</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Occupation:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span v-if="customerDetails
                                        .occupationInfo
                                        .occupation
                                    " class="">{{
                                    customerDetails
                                        .occupationInfo
                                        .occupation
                                }}</span>
                                                    <span v-else>N/A</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Source of Funds:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span v-if="customerDetails
                                        .occupationInfo
                                        .sourceOfFunds
                                    " class="">{{
                                    customerDetails
                                        .occupationInfo
                                        .sourceOfFunds
                                }}</span>
                                                    <span v-else>N/A</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Monthly Income of
                                                        Client:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span v-if="customerDetails
                                        .accountInfo
                                        .monthlyIncome
                                    " class="">{{
                                    customerDetails
                                        .accountInfo
                                        .monthlyIncome
                                }}</span>
                                                    <span v-else>N/A</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <!-- End Professional Information -->

                        <!-- Identity Information -->
                        <ul v-if="customerDetails.identityInfo">
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>ID Document</h3>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Document Type:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                    customerDetails
                                        .identityInfo.type
                                    | identityInfoType
                                }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>ID Number:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .identityInfo.number
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Expiry Date:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span v-if="customerDetails
                                        .identityInfo
                                        .expiryDate
                                    " :class="addDangerClass(
                                    customerDetails
                                        .identityInfo
                                        .expiryDate
                                )
                                    ">{{
                                    customerDetails
                                        .identityInfo
                                        .expiryDate
                                    | moment(
                                        'MMM D, YYYY'
                                    )
                                }}</span>
                                                    <span v-else>Lifetime Expiry</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <!-- Nominee Details -->
                        <ul v-if="customerDetails.accountInfo">
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>Nominee Information</h3>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Name
                                                        (Mr./Ms./Mrs.):</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                    customerDetails
                                        .accountInfo
                                        .nomineeName1
                                        ? customerDetails
                                            .accountInfo
                                            .nomineeName1
                                        : 'N/A'
                                }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Father's/Husband's
                                                        Name:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .accountInfo
                                            .nomineeFatherName1
                                            ? customerDetails
                                                .accountInfo
                                                .nomineeFatherName1
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>CNIC/NICOP No.:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .accountInfo
                                            .nomineeCNIC1
                                            ? customerDetails
                                                .accountInfo
                                                .nomineeCNIC1
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Mailing Address:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .accountInfo
                                            .nomineeAddress1
                                            ? customerDetails
                                                .accountInfo
                                                .nomineeAddress1
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <!-- <div class="filter-section sub-filter">
                            <div class="row sup-heading">
                                <div class="col-md-11">
                                    <h2 class="m-0">Additional Info</h2>
                                </div>
                                <span class="edit-info" @click="editAccountInfo"
                                    ><i class="icon-edit"></i>Edit
                                </span>
                            </div>
                        </div> -->

                        <div class="filter-section sub-filter">
                            <div class="row sup-heading">
                                <div class="col-md-11">
                                    <h2 class="m-0">KYC</h2>
                                </div>
                                <span class="edit-info" @click="editKyc"><i class="icon-edit"></i>Edit
                                </span>
                            </div>
                        </div>
                        <ul v-if="customerDetails.pepInfo">
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>
                                                KYC Questionnaire / PEP
                                                Declaration
                                            </h3>
                                        </div>
                                        <div v-for="(
                                                item, index
                                            ) in pepDeclaration" :key="index" class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>{{
                                    item.field
                                }}</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        item.value
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <ul v-if="customerDetails.accountInfo">
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>
                                                Account Management Instructions
                                            </h3>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Instruction to Operate
                                                        Account:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                    customerDetails
                                        .accountInfo
                                        .operateAccount
                                        ? customerDetails
                                            .accountInfo
                                            .operateAccount
                                        : 'N/A'
                                }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <!-- <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label
                                                        >Others (please
                                                        specify):</label
                                                    >
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                                        customerDetails
                                                            .accountInfo
                                                            .operateAccountOther
                                                            ? customerDetails
                                                                  .accountInfo
                                                                  .operateAccountOther
                                                            : 'N/A'
                                                    }}</span>
                                                </li>
                                            </ul>
                                        </div> -->
                                        <!-- <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label
                                                        >Cash Dividend:</label
                                                    >
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                                        customerDetails
                                                            .accountInfo
                                                            .cashDividend
                                                            ? customerDetails
                                                                  .accountInfo
                                                                  .cashDividend
                                                            : 'N/A'
                                                    }}</span>
                                                </li>
                                            </ul>
                                        </div> -->
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Payout
                                                        Instructions:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .accountInfo
                                            .stockDividend
                                            ? customerDetails
                                                .accountInfo
                                                .stockDividend
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>Do you wish to receive
                                                        Statement of
                                                        Accounts?</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .accountInfo
                                            .receiveAccountStatement
                                            ? customerDetails
                                                .accountInfo
                                                .receiveAccountStatement
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>(If Yes, please select
                                                        the nature of
                                                        Mail):</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .accountInfo
                                            .mailNature
                                            ? customerDetails.accountInfo.mailNature.join(
                                                ', '
                                            )
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>For All Other
                                                        Correspondence:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        customerDetails
                                            .accountInfo
                                            .mailNatureMisc
                                            ? customerDetails.accountInfo.mailNatureMisc.join(
                                                ', '
                                            )
                                            : 'N/A'
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <ul v-if="customerDetails.fatcaInfo">
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>FATCA Information</h3>
                                        </div>
                                        <div v-for="(
                                                item, index
                                            ) in fatcaDetails" :key="index" class="col-md-4">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>{{
                                    item.field
                                }}</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        item.value
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <ul v-if="customerDetails.w9Info">
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>W-9 Form (For US Citizens)</h3>
                                        </div>
                                        <div v-for="(item, index) in w9Info" :key="index" class="col-md-4">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>{{
                                    item.field
                                }}</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        item.value
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-4">
                                                    <label>Account Number:</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                    customerDetails.w9Info
                                        .accountNumber
                                        ? customerDetails
                                            .w9Info
                                            .accountNumber
                                        : 'N/A'
                                }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <ul v-if="customerDetails.crsInfo">
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>
                                                CRS Form for Tax Residency Self
                                                Certification
                                            </h3>
                                        </div>
                                        <div v-for="(item, index) in crsForm" :key="index" class="col-md-4">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>{{
                                    item.field
                                }}</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                        item.value
                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="filter-section sub-filter">
                            <div class="row sup-heading">
                                <div class="col-md-11">
                                    <h2 class="m-0">Investment</h2>
                                </div>
                                <span class="edit-info" @click="editInvestment"><i class="icon-edit"></i>Edit
                                </span>
                            </div>
                        </div>
                        <ul v-if="customerDetails.investmentProduct">
                            <li>
                                <div class="seprator-section">
                                    <div class="row">
                                        <div v-for="(
                                                item, index
                                            ) in customerDetails
                                        .investmentProduct
                                        .selectOptions" :key="index" class="col-md-6">
                                            <ul class="row">
                                                <li class="col-md-6">
                                                    <label>{{
                                                        item.quesTitle
                                                        }}</label>
                                                </li>
                                                <li class="col-md-6">
                                                    <span class="">{{
                                                        item.optionTitle
                                                        }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="filter-section sub-filter">
                            <div class="row sup-heading">
                                <div class="col-md-11">
                                    <h2 class="m-0">Risk Profiling</h2>
                                </div>
                            </div>
                            <ul v-if="customerDetails.accountInfo">
                                <li>
                                    <div class="seprator-section">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <ul class="row">
                                                    <li class="col-md-6">
                                                        <label>Selected
                                                            Risk:</label>
                                                    </li>
                                                    <li class="col-md-6">
                                                        <span>{{
                                                            customerDetails
                                                            .investmentProduct
                                                            .tolerance
                                                            ? customerDetails
                                                            .investmentProduct
                                                            .tolerance
                                                            : 'N/A'
                                                            }}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-6">
                                                <ul class="row">
                                                    <li class="col-md-6">
                                                        <label>Score:</label>
                                                    </li>
                                                    <li class="col-md-6">
                                                        <span>{{
                                                            customerDetails
                                                            .investmentProduct
                                                            .score
                                                            ? customerDetails
                                                            .investmentProduct
                                                            .score
                                                            : 'N/A'
                                                            }}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-6">
                                                <ul class="row">
                                                    <li class="col-md-6">
                                                        <label>Recommended
                                                            Risk:</label>
                                                    </li>
                                                    <li class="col-md-6">
                                                        <span class="">{{
                                                            customerDetails
                                                            .investmentProduct
                                                            .recommendedRisk
                                                            .title
                                                            ? customerDetails
                                                            .investmentProduct
                                                            .recommendedRisk
                                                            .title
                                                            : 'N/A'
                                                            }}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-6">
                                                <ul class="row">
                                                    <li class="col-md-6">
                                                        <label>Disclaimer:</label>
                                                    </li>
                                                    <li class="col-md-6">
                                                        <span>{{
                                                            customerDetails
                                                            .investmentProduct
                                                            .disclaimer
                                                            ? customerDetails
                                                            .investmentProduct
                                                            .disclaimer
                                                            : 'N/A'
                                                            }}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-6">
                                                <ul class="row">
                                                    <li class="col-md-6">
                                                        <label>Fund Risk
                                                            Category:</label>
                                                    </li>
                                                    <li class="col-md-6">
                                                        <span>{{
                                                            customerDetails
                                                            .investmentProduct
                                                            .secpProduct
                                                            ? customerDetails
                                                            .investmentProduct
                                                            .secpProduct
                                                            : 'N/A'
                                                            }}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-6">
                                                <ul class="row">
                                                    <li class="col-md-6">
                                                        <label>Recommended Fund(s)
                                                            as per Fund Risk
                                                            Category:</label>
                                                    </li>
                                                    <li class="col-md-6">
                                                        <span v-for="(
                                                                item, index
                                                            ) in customerDetails
                                    .investmentProduct
                                    .selectedProductsNames" :key="index">{{ item }} <br />
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-3">
                <b-button size="sm" variant="secondary" class="mr-3" @click="onBack">
                    Back
                </b-button>
                <b-button type="button" variant="primary" class="primary-add-btn" @click="onSubmitContinue">CONTINUE
                </b-button>
            </div>
            <b-modal ref="termsandconditionmodal" size="md" title="" hide-footer :click-to-close="false"
                :no-close-on-backdrop="true" :no-close-on-esc="true">
                <terms-and-condition @agreed="agreeToTermsAndConditions"></terms-and-condition>
            </b-modal>

            <div class="col-lg-4"></div>
            <b-modal ref="my-modal" size="lg" title="" hide-footer :click-to-close="false" :no-close-on-backdrop="true"
                :no-close-on-esc="true">
                <modal-setup-profile @close="handleClose">
                </modal-setup-profile>
            </b-modal>
            <b-modal ref="modalRecaptcha" size="sm" title="" hide-footer :click-to-close="false"
                :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="true">
                <div class="col-sm-10">
                    <recaptcha @onVerify="onVerify"> </recaptcha>
                </div>
            </b-modal>
            <b-modal ref="otpmodal" size="sm" title="" hide-footer :click-to-close="false" :no-close-on-backdrop="true"
                :no-close-on-esc="true" @close="onCloseOTPModal">
                <otp-verification-modal :data="otpData" @verificationStatus="otpResponse" @OTPAfterCaptcha="submitOTP"
                    @reSendOTP="reSendOTP"></otp-verification-modal>
            </b-modal>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import TermsAndCondition from '@/components/registration/TermsAndCondition.vue'
import OtpModal from '@/components/registration/OtpModal.vue'
import ModalSetupProfile from '@/components/registration/ModalSetupProfile.vue'
import request from '@/utils/request'
import Recaptcha from '@/components/registration/Recaptcha.vue'
import OtpVerificationModal from '../../components/registration/OtpVerificationModal'
import _ from 'lodash'

export default {
    components: {
        TermsAndCondition,
        OtpModal,
        ModalSetupProfile,
        Recaptcha,
        OtpVerificationModal
    },
    filters: {
        identityInfoType: function (value) {
            switch (value) {
                case 'id':
                    return 'National ID Card'

                case 'nicop':
                    return 'National Identity Card for Overseas Pakistanis'

                case 'poc':
                    return 'Pakistan Origin Card'

                case 'arc':
                    return 'National Alien Registration System'

                case 'licence':
                    return 'Driving Licence'

                case 'passport':
                    return 'Passport'
            }
        },
    },
    data() {
        return {
            customerDetails: [],
            basicInfo: [],
            pepDeclaration: [],
            fatcaDetails: [],
            crsForm: [],
            w9Info: [],
            otpData: null,
            is_data_fetched: false,
            recaptchaResponse: '',
            // pmd: [],
        }
    },
    mounted() {
        this.$store.dispatch('trackEvent', { event: "JS | SSA Register Preview" });

        // this.$analytics.fbq.init('651215232540859', {
        // em: 'user@mail.com'
        // })
        // console.log(
        //     'Final-Customer-Data: ' +
        //         JSON.stringify(this.$store.state.registration.form)
        // )
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        // ...mapState({
        //     userOcr: (state) => state.registration.useOcr,
        // }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    created() {
        this.customerDetails = this.$store.state.registration.form
        // console.log('States: ' + JSON.stringify(this.customerDetails))
        this.setValues()
    },
    methods: {
        handleClose(event) {
            this.$refs['my-modal'].hide()
        },
        editSetupProfile() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-setup-profile-ssa',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push('/ssa-customer/setup-profile')
                // alert('Error in Opening Setup Profile Edit')
            }
        },
        editAccountInfo() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-additional-info-ssa',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push('/ssa-customer/additional-info')
                // alert('Error in Opening Setup Profile Edit')
            }
        },
        editKyc() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-kyc-ssa',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                // this.$router.push('/register-customer/finish')
                this.$router.push('/ssa-customer/kyc')
                // alert('Error in Opening Setup Profile Edit')
            }
        },
        editInvestment() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-investment-ssa',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push('/ssa-customer/investment')
                // alert('Error in Opening Setup Profile Edit')
            }
        },
        setSSAInfo() {
            if (!this.$store.state.registration.form.basicInfo.zakat) {
                // let zakat = this.$store.state.registration.form.basicInfo.zakat
                this.$store.commit('updateField', {
                    key: 'asaanAccInfo.zakatDeduction',
                    value: 'N',
                })
            }
            if (this.$store.state.registration.form.basicInfo.permPakResident) {
                let res =
                    this.$store.state.registration.form.basicInfo
                        .permPakResident
                this.$store.commit('updateField', {
                    key: 'asaanAccInfo.resident',
                    value: res.slice(0, 1),
                })
            }
            if (this.$store.state.registration.form.basicInfo.religion) {
                let religion =
                    this.$store.state.registration.form.basicInfo.religion.replace(
                        /-/g,
                        ''
                    )
                this.$store.commit('updateField', {
                    key: 'asaanAccInfo.religion',
                    value: religion,
                })
            }
        },
        async onSubmitContinue() {
            this.setSSAInfo()
            // this.$store.commit('setLoading', true)
            if (this.$route.meta.publicRegistration === true) {
                console.log('fb script call start')
                window.fbq('track', 'PageView')

                this.$analytics.fbq.event('ViewContent', {
                    content_name: 'Customer Registered',
                })
                console.log('fb script call end')
                this.$refs.termsandconditionmodal.show()
            } else {
                let registrationUrl = '/customers/non-face-to-face'
                this.$store.commit('setLoading', true)

                try {
                    const formData = this.$store.state.registration.form
                    formData.dataSegmentId = this.dataSegmentId

                    const { data } = await request({
                        url: registrationUrl,
                        method: 'post',
                        data: formData,
                    })

                    this.$store.commit('updateField', {
                        key: 'idenfoId',
                        value: data.data.idenfoId,
                    })

                    if (this.$route.meta.publicRegistration === true) {
                        this.$router.push({
                            name: 'public-registration-finish-ssa',
                            params: {
                                dataSegmentId: this.dataSegmentId,
                            },
                        })
                    } else {
                        this.$router.push('/ssa-customer/finish')
                    }

                    this.$store.commit('setLoading', false)
                } catch (errors) {
                    this.$store.commit('setError', errors)
                    this.$store.commit('setLoading', false)
                }
            }
        },
        agreeToTermsAndConditions() {
            this.$refs.modalRecaptcha.show()
            // this.sendOPT()
        },
        async onVerify(response) {
            if (response) {
                this.recaptchaResponse = response
                this.$refs.modalRecaptcha.hide()
                // this.sendOTP()
                this.submitOTP()
            }
        },

        async sendOTP() {
            try {
                let phoneNumber =
                    this.$store.state.registration.form.contactInfo.isdCode.replace(
                        /\+/g,
                        ''
                    ) +
                    this.$store.state.registration.form.contactInfo.phoneNumber
                let fullName =
                    this.$store.state.registration.form.basicInfo.firstName
                let email =
                    this.$store.state.registration.form.contactInfo.email
                let recieveOtpOption = ['sms', 'email']

                this.$store.commit('setLoading', true)

                const formData = {
                    mobileNo: phoneNumber,
                    name: fullName,
                    email: email,
                    recieveOtpOption: recieveOtpOption,
                }

                // console.log('PHONE NUMBER: ' + phoneNumber)

                const { data } = await request({
                    url: `/configurations/generate-otp/`,
                    method: 'post',
                    data: formData,
                })
                console.log('dataOTPGET ', JSON.stringify(data))
                if (data) {
                    data.data.phoneNumber = phoneNumber
                    this.otpData = data

                    this.$refs.otpmodal.show()
                }

                // this.showPageLoader = false
                // console.log('Response OTP data: ' + JSON.stringify(data))
                // this.fields = data.data
            } catch (error) {
                // console.log('OTP error: ' + error)
            }

            this.$store.commit('setLoading', false)
        }, // End of sendOtp() method

        async submitOTP() {
            this.$store.commit('setLoading', true)

            const result = await this.$validator.validateAll()

            if (result) {
                const formData = {
                    otpCode: '',
                    token: '',
                    mobileNo: '',
                    cToken: this.recaptchaResponse,
                    // customerData :  this.$store.state.registration.form,
                    // dataSegmentId : this.dataSegmentId
                }
                var str = this.$store.getters.getField('identityInfo.number')
                var newStr = str.replace(/-/g, '')
                this.$store.commit('updateField', {
                    key: 'identityInfo.number',
                    value: newStr,
                })

                formData.customerData = this.$store.state.registration.form
                formData.customerData.dataSegmentId = this.dataSegmentId

                // console.log("encrypt: "+JSON.stringify(formData))

                let encryptedForm = this.CryptoJS.AES.encrypt(
                    JSON.stringify(formData),
                    process.env.VUE_APP_CRYPTO_SECERT_KEY
                ).toString()
                // console.log("encrypt: "+encryptedForm)
                const { data } = await request({
                    url: `/configurations/verify-otp`,
                    method: 'post',
                    data: { data: encryptedForm },
                })

                if (data) {
                    // this.$emit('verificationStatus', data.data)
                    this.otpResponse(data.data)
                    console.log('data.data', data.data)
                    if (data.data.verificationStatus == false) {
                        this.isError = data.data.message
                    }

                    this.$store.commit('setLoading', false)
                } else {
                    this.$store.commit('setError', this.errors.all()[0])
                    this.$store.commit('setLoading', false)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
                this.$store.commit('setLoading', false)
            }
        },

        onCloseOTPModal() {
            this.$store.commit('setLoading', false)
        }, // End of pnCloseOTPModal() method

        async otpResponse(data) {
            // console.log('emi data: ' + JSON.stringify(data))

            this.$store.commit('setLoading', true)

            if (data.verificationStatus == true) {
                this.$store.commit('updateField', {
                    key: 'idenfoId',
                    value: data.idenfoId,
                })

                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'public-registration-finish-ssa',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    this.$router.push('/ssa-customer/finish')
                }

                // this.$refs.otpmodal.hide()
                this.$store.commit('setLoading', false)
            } else {
                this.$store.commit('setError', 'error')
            }

            // this.$store.commit('setLoading', false)
        }, // End of otpResponse() method

        addDangerClass(date) {
            let expiryDate = this.$moment(date)
            let diff = expiryDate.diff(this.$moment(), 'days')
            if (diff <= 60) {
                return 'danger'
            }
            return ''
        },

        async reSendOTP() {
            this.sendOTP()
        }, // End of reSendOTP() method

        setValues() {
            if (this.customerDetails && this.customerDetails.basicInfo) {
                //Basic Info
                this.basicInfo.push(
                    {
                        field: 'Full Name',
                        value: this.customerDetails.basicInfo.firstName
                            ? this.customerDetails.basicInfo.firstName
                            : 'N/A',
                    },
                    {
                        field: 'Father’s/Husband’s Name',
                        value: this.customerDetails.basicInfo
                            .fatherOrHusbandName
                            ? this.customerDetails.basicInfo.fatherOrHusbandName
                            : 'N/A',
                    },
                    {
                        field: 'Mother’s Name',
                        value: this.customerDetails.basicInfo.motherName
                            ? this.customerDetails.basicInfo.motherName
                            : 'N/A',
                    },
                    {
                        field: 'Gender',
                        value: this.customerDetails.basicInfo.gender
                            ? this.customerDetails.basicInfo.gender
                            : 'N/A',
                    },
                    {
                        field: 'Date of Birth',
                        value: this.customerDetails.basicInfo.dateOfBirth
                            ? moment(
                                this.customerDetails.basicInfo.dateOfBirth
                            ).format('YYYY-MM-DD')
                            : 'N/A',
                    },
                    {
                        field: 'Religion',
                        value: this.customerDetails.basicInfo.religion
                            ? this.customerDetails.basicInfo.religion
                            : 'N/A',
                    },
                    {
                        field: 'Zakat Deduction',
                        value: this.customerDetails.basicInfo.zakat
                            ? this.customerDetails.basicInfo.zakat
                            : 'N/A',
                    },
                    {
                        field: 'Marital Status',
                        value: this.customerDetails.basicInfo.maritalStatus
                            ? this.customerDetails.basicInfo.maritalStatus
                            : 'N/A',
                    }
                )
                this.pepDeclaration.push(
                    {
                        field: 'Are you a resident/ national of any country other than Pakistan?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.declarationPEP1
                                ? this.customerDetails.pepInfo.declarationPEP1
                                : 'N/A',
                    },
                    {
                        field: 'Do you belong to a country that is not part of FATF (Financial Action Task Force*)?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.declarationPEP2
                                ? this.customerDetails.pepInfo.declarationPEP2
                                : 'N/A',
                    },
                    {
                        field: 'Do you have any business relationship or transactions in/ from offshore tax haven countries?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.declarationPEP3
                                ? this.customerDetails.pepInfo.declarationPEP3
                                : 'N/A',
                    },
                    {
                        field: 'Has any financial institution ever refused to open your account?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.declarationPEP4
                                ? this.customerDetails.pepInfo.declarationPEP4
                                : 'N/A',
                    },
                    {
                        field: 'Do you deal in high value items i.e. Gold, silver, diamonds, metals, gems etc.?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.declarationPEP5
                                ? this.customerDetails.pepInfo.declarationPEP5
                                : 'N/A',
                    },
                    {
                        field: 'Are you a resident or inhabitant of southern punjab or afghan border?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.declarationPEP6
                                ? this.customerDetails.pepInfo.declarationPEP6
                                : 'N/A',
                    },
                    {
                        field: 'Do you hold a high profile position i.e. sports or media personality?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.declarationPEP7
                                ? this.customerDetails.pepInfo.declarationPEP7
                                : 'N/A',
                    },
                    {
                        field: 'Are you acting on behalf of any other person? (if yes, please provide "declaration for ultimate beneficial ownership")',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.declarationPEP8
                                ? this.customerDetails.pepInfo.declarationPEP8
                                : 'N/A',
                    },
                    {
                        field: 'Name of Ultimate Beneficial Ownership',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.nameUBO
                                ? this.customerDetails.pepInfo.nameUBO
                                : 'N/A',
                    },
                    {
                        field: 'CNIC of Ultimate Beneficial Ownership',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.cnicUBO
                                ? this.customerDetails.pepInfo.cnicUBO
                                : 'N/A',
                    },
                    {
                        field: 'Are you a domestic or foreign "Politically Exposed Person" (PEP)?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.declarationPEP9
                                ? this.customerDetails.pepInfo.declarationPEP9
                                : 'N/A',
                    },

                    {
                        field: 'Are you a family member or close associate of a domestic or foreign "Politically Exposed Person" (PEP)?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.pepInfo &&
                                this.customerDetails.pepInfo.declarationPEP10
                                ? this.customerDetails.pepInfo.declarationPEP10
                                : 'N/A',
                    }
                )
                this.fatcaDetails.push(
                    {
                        field: 'Title of Account:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.titleOfAcc &&
                                this.customerDetails.fatcaInfo.titleOfAcc
                                ? this.customerDetails.fatcaInfo.titleOfAcc
                                : 'N/A',
                    },
                    {
                        field: 'CNIC No.:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.CNICNumber
                                ? this.customerDetails.fatcaInfo.CNICNumber
                                : 'N/A',
                    },
                    {
                        field: 'Country of Residence:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.countryOfResidence
                                ? this.customerDetails.fatcaInfo
                                    .countryOfResidence
                                : 'N/A',
                    },
                    {
                        field: 'Country of Incorporation (For Entities):',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.countryOfIncorp
                                ? this.customerDetails.fatcaInfo.countryOfIncorp
                                : 'N/A',
                    },
                    {
                        field: 'Place of Birth:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.placeOfBirth
                                ? this.customerDetails.fatcaInfo.placeOfBirth
                                : 'N/A',
                    },
                    {
                        field: 'Are you a US Citizen?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.isUSCitizen
                                ? this.customerDetails.fatcaInfo.isUSCitizen
                                : 'N/A',
                    },
                    {
                        field: 'Are you a US Resident?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.isUSResident
                                ? this.customerDetails.fatcaInfo.isUSResident
                                : 'N/A',
                    },
                    {
                        field: 'Do you hold US Permanent Resident Card (Green Card)?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.greenCardUS
                                ? this.customerDetails.fatcaInfo.greenCardUS
                                : 'N/A',
                    },
                    {
                        field: 'Are you a resident/citizen of any country other than Pakistan?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.CountryResidentOption
                                ? this.customerDetails.fatcaInfo
                                    .CountryResidentOption
                                : 'N/A',
                    },
                    {
                        field: 'Country of residence other than Pakistan',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.CountryResidentTitle
                                ? this.customerDetails.fatcaInfo
                                    .CountryResidentTitle
                                : 'N/A',
                    },
                    {
                        field: 'Do you have any tax obligation in a country other than Pakistan?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.CountryTaxOption
                                ? this.customerDetails.fatcaInfo
                                    .CountryTaxOption
                                : 'N/A',
                    },
                    {
                        field: 'Country of tax obligation other than Pakistan',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.CountryTaxTitle
                                ? this.customerDetails.fatcaInfo.CountryTaxTitle
                                : 'N/A',
                    },

                    {
                        field: 'Are you Dual National?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.dualNational
                                ? this.customerDetails.fatcaInfo.dualNational
                                : 'N/A',
                    },
                    {
                        field: 'Country of dual nationality',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo
                                    .dualNationalCountryTitle
                                ? this.customerDetails.fatcaInfo
                                    .dualNationalCountryTitle
                                : 'N/A',
                    },
                    {
                        field: 'Are you a U.S. Owned Entity/ any other country?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.isUSEntity
                                ? this.customerDetails.fatcaInfo.isUSEntity
                                : 'N/A',
                    },
                    {
                        field: 'Have you given power of attorney to anyone residing overseas?',
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.IsPowerAttorney
                                ? this.customerDetails.fatcaInfo.IsPowerAttorney
                                : 'N/A',
                    },
                    {
                        field: "Power of Attorney's Address:",
                        value:
                            this.customerDetails &&
                                this.customerDetails.fatcaInfo &&
                                this.customerDetails.fatcaInfo.PowerAttorneyAdd
                                ? this.customerDetails.fatcaInfo
                                    .PowerAttorneyAdd
                                : 'N/A',
                    }
                )
                this.w9Info.push(
                    {
                        field: 'Name (as shown on your income tax return):',
                        value:
                            this.customerDetails &&
                                this.customerDetails.w9Info &&
                                this.customerDetails.w9Info.fullName &&
                                this.customerDetails.w9Info.fullName
                                ? this.customerDetails.w9Info.fullName
                                : 'N/A',
                    },
                    {
                        field: 'Business name / disregarded entity name:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.w9Info &&
                                this.customerDetails.w9Info.businessName &&
                                this.customerDetails.w9Info.businessName
                                ? this.customerDetails.w9Info.businessName
                                : 'N/A',
                    },
                    {
                        field: 'Select appropriate option for federal tax classification:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.w9Info &&
                                this.customerDetails.w9Info.federalTax &&
                                this.customerDetails.w9Info.federalTax
                                ? this.customerDetails.w9Info.federalTax
                                : 'N/A',
                    },
                    {
                        field: 'Exempt Payee Code (if any):',
                        value:
                            this.customerDetails &&
                                this.customerDetails.w9Info &&
                                this.customerDetails.w9Info.payeeCode &&
                                this.customerDetails.w9Info.payeeCode
                                ? this.customerDetails.w9Info.payeeCode
                                : 'N/A',
                    },
                    {
                        field: 'Exemption from FATCA reporting code (if any)',
                        value:
                            this.customerDetails &&
                                this.customerDetails.w9Info &&
                                this.customerDetails.w9Info.fatcaCode &&
                                this.customerDetails.w9Info.fatcaCode
                                ? this.customerDetails.w9Info.fatcaCode
                                : 'N/A',
                    },
                    {
                        field: 'Residential Address:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.w9Info &&
                                this.customerDetails.w9Info.address &&
                                this.customerDetails.w9Info.address
                                ? this.customerDetails.w9Info.address
                                : 'N/A',
                    },
                    {
                        field: 'City:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.w9Info &&
                                this.customerDetails.w9Info.city &&
                                this.customerDetails.w9Info.city
                                ? this.customerDetails.w9Info.city
                                : 'N/A',
                    },
                    {
                        field: 'State:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.w9Info &&
                                this.customerDetails.w9Info.state &&
                                this.customerDetails.w9Info.state
                                ? this.customerDetails.w9Info.state
                                : 'N/A',
                    },
                    {
                        field: 'Zip Code:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.w9Info &&
                                this.customerDetails.w9Info.zipCode &&
                                this.customerDetails.w9Info.zipCode
                                ? this.customerDetails.w9Info.zipCode
                                : 'N/A',
                    },

                    {
                        field: 'Taxpayer Identification Number (TIN):',
                        value:
                            this.customerDetails &&
                                this.customerDetails.w9Info &&
                                this.customerDetails.w9Info.tin &&
                                this.customerDetails.w9Info.tin
                                ? this.customerDetails.w9Info.tin
                                : 'N/A',
                    }
                )
                this.crsForm.push(
                    {
                        field: 'Country of Tax Residence:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsCountryTaxTitle1 &&
                                this.customerDetails.crsInfo.crsCountryTaxTitle1
                                ? this.customerDetails.crsInfo
                                    .crsCountryTaxTitle1
                                : 'N/A',
                    },
                    {
                        field: 'Country of Tax Residence #2:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsCountryTaxTitle2 &&
                                this.customerDetails.crsInfo.crsCountryTaxTitle2
                                ? this.customerDetails.crsInfo
                                    .crsCountryTaxTitle2
                                : 'N/A',
                    },
                    {
                        field: 'Country of Tax Residence #3:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsCountryTaxTitle3 &&
                                this.customerDetails.crsInfo.crsCountryTaxTitle3
                                ? this.customerDetails.crsInfo
                                    .crsCountryTaxTitle3
                                : 'N/A',
                    },
                    {
                        field: 'TIN or Equivalent:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsTIN1 &&
                                this.customerDetails.crsInfo.crsTIN1
                                ? this.customerDetails.crsInfo.crsTIN1
                                : 'N/A',
                    },
                    {
                        field: 'TIN or Equivalent:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsTIN2 &&
                                this.customerDetails.crsInfo.crsTIN2
                                ? this.customerDetails.crsInfo.crsTIN2
                                : 'N/A',
                    },
                    {
                        field: 'TIN or Equivalent:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsTIN3 &&
                                this.customerDetails.crsInfo.crsTIN3
                                ? this.customerDetails.crsInfo.crsTIN3
                                : 'N/A',
                    },
                    {
                        field: 'Reason:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsReason1 &&
                                this.customerDetails.crsInfo.crsReason1
                                ? this.customerDetails.crsInfo.crsReason1
                                : 'N/A',
                    },
                    {
                        field: 'Reason:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsReason2 &&
                                this.customerDetails.crsInfo.crsReason2
                                ? this.customerDetails.crsInfo.crsReason2
                                : 'N/A',
                    },
                    {
                        field: 'Reason:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsReason3 &&
                                this.customerDetails.crsInfo.crsReason3
                                ? this.customerDetails.crsInfo.crsReason3
                                : 'N/A',
                    },
                    {
                        field: 'If reason B selected, please explain why you are unable to obtain a TIN or functional Equivalent:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsOtherReason1 &&
                                this.customerDetails.crsInfo.crsOtherReason1
                                ? this.customerDetails.crsInfo.crsOtherReason1
                                : 'N/A',
                    },

                    {
                        field: 'If reason B selected, please explain why you are unable to obtain a TIN or functional Equivalent:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsOtherReason2 &&
                                this.customerDetails.crsInfo.crsOtherReason2
                                ? this.customerDetails.crsInfo.crsOtherReason2
                                : 'N/A',
                    },

                    {
                        field: 'If reason B selected, please explain why you are unable to obtain a TIN or functional Equivalent:',
                        value:
                            this.customerDetails &&
                                this.customerDetails.crsInfo &&
                                this.customerDetails.crsInfo.crsOtherReason3 &&
                                this.customerDetails.crsInfo.crsOtherReason3
                                ? this.customerDetails.crsInfo.crsOtherReason3
                                : 'N/A',
                    }
                )
            } // End of Condition
        },

        onBack() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-upload-document-ssa',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push('/ssa-customer/upload-document')
            }
        },
    },
}
</script>
